import { type ButtonHTMLAttributes, type ReactNode } from 'react'
import { buttonVariants } from './CtaButton.variants'

export interface CtaButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  status: 'active' | 'inactive'
  label?: string
  icon?: ReactNode
  accentColor?: 'none' | 'yellow' | 'green' | 'blue'
}

export const CtaButton = ({ status, className, label, icon, accentColor = 'yellow', ...props }: CtaButtonProps) => {
  const showDivider = label && icon

  return (
    <button className={buttonVariants({ status, accentColor, className })} disabled={status === 'inactive'} type="button"  {...props}>
      {label ? <span className="text-white text-base font-bold">{label}</span> : null}
      {showDivider ? <div className="w-px h-full bg-white opacity-[.33]" /> : null}
      {icon}
    </button>
  )
}

CtaButton.displayName = 'CtaButton'
